import { EntityFormState } from '../../entity-form/interfaces/entity-form';

export function templateFormConnectionParamsFactory(values: EntityFormState, entityType?: string) {
  const { name, ...rest } = values;

  return {
    name,
    type: entityType,
    config: {
      ...rest
    }
  };
}
